/* global axios */
import ApiClient from './ApiClient';

class WiseUsersAPI extends ApiClient {
  constructor() {
    super('wise/users', { accountScoped: true });
  }
}

export default new WiseUsersAPI();
